import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';
import { GameBackside, GameHolder } from '@pascal/pascal-core/table-line';
import {
  FreeBetsWrapper,
  LocalStorageWrapper,
  useTranslation,
  UnderMaintenanceWr,
  SlowConnectionWr,
  platformMessageStore,
} from '@pascal/pascal-core';

import { gameStore } from '../../store/gameStore';
import { GameContent } from '../../containers/gameContent';
import TurboModePopUp from '../../components/turboModePopUp';
import { TranslationKeys } from '../../enums/translationKeys';
import { specificLocalStorageKeys } from '../../enums/constants';

const WebGameMain = observer(() => {
  const { isDemo } = applicationStore;
  const { resetGameState, isTurboModeExist } = gameStore;
  const { isRepliedGame } = platformMessageStore;
  const t = useTranslation();

  const handleDemoSwitcher = useCallback(() => {
    applicationStore.demoSwitcher(resetGameState);
  }, [resetGameState]);

  return (
    <>
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <GameHolder>
        <GameBackside />
        <div className='crazy-worm-game-container'>
          {isDemo && (
            <button type='button' className='play-for-real-btn' onClick={handleDemoSwitcher}>
              {t(TranslationKeys.PlayForReal)}
            </button>
          )}
          <FreeBetsWrapper />
          <GameContent />
          {!isRepliedGame && isTurboModeExist && (
            <LocalStorageWrapper localStorageKey={specificLocalStorageKeys.isTurboModePopUp}>
              <TurboModePopUp t={t} />
            </LocalStorageWrapper>
          )}
        </div>
      </GameHolder>
    </>
  );
});

export default WebGameMain;
